// PageNavMenuReportItem
// ***********************************************************************************************************************
import CheckIcon from "@mui/icons-material/Check";
import { ListItem, ListItemAvatar, Tooltip, alpha } from "@mui/material";
import * as React from "react";
import { FileType, ReportType } from "ui/Scripts/source/models/enums";
import { IReportItem, ReportItem } from "../../../../models/report/reportItem";
import { AttachmentIcon } from "../../../attachments/AttachmentIcon";
import { EllipsisTypography } from "../../../framework/Typography/EllipsisTypography";

export interface IPageNavMenuReportItemItem {
    reportItem: IReportItem;
    title: string;
}

export class PageNavMenuReportItemItem implements IPageNavMenuReportItemItem {
    reportItem: ReportItem;
    title: string;

    constructor();
    constructor(obj: IPageNavMenuReportItemItem);
    constructor(obj?: any) {
        this.title = obj && obj.title || "";
        this.reportItem = null;
        if (obj && obj.reportItem) {
            this.reportItem = new ReportItem(obj.reportItem);
        }
    }
}

// PageNavMenuReportItemReportLine
export interface IPageNavMenuReportItemReportLineProp {
    classes?: boolean;
    item: IReportItem;
    canRemoveSharedReports: boolean;
    activeItemId: string;
    onSetActiveItem: (reportId: string) => void;
}

export class PageNavMenuReportItemReportLine extends React.Component<IPageNavMenuReportItemReportLineProp, {}> {
    handleOnClick = (ev, reportId: string) => {
        const props = this.props;
        ev.stopPropagation();
        if (!props.onSetActiveItem) return;
        props.onSetActiveItem(reportId);
    };

    render() {
        const props = this.props;
        if (!props.item) return null;
        const report = props.item;
        const selected = props.activeItemId === props.item.id;

        return (
            <ListItem
                unselectable="off"
                onClick={(ev) => this.handleOnClick(ev, report.id) }
                secondaryAction={(
                    <>
                        {selected && (
                            <CheckIcon fontSize="small" color="primary" />
                        )}
                    </>
                )}
                sx={(theme) => ({
                    "border": "1px solid",
                    "borderColor": theme.palette.divider,
                    "padding": "2px 12px",
                    "margin": "8px 0",
                    "cursor": "pointer",
                    "background": selected
                        ? alpha(
                            theme.palette.primary.main,
                            theme.palette.action.selectedOpacity
                        )
                        : undefined,
                    "&:hover": {
                        background: selected
                            ? alpha(
                                theme.palette.primary.main,
                                theme.palette.action.selectedOpacity +
                                            theme.palette.action.hoverOpacity
                            )
                            : theme.palette.action.hover
                    }
                })}
            >
                <ListItemAvatar>
                    <Tooltip title={report.getTypeTitle()}>
                        <span>
                            <AttachmentIcon fileType={report.type === ReportType.Html
                                ? FileType.Html
                                : (report.type === ReportType.Pdf
                                    ? FileType.Pdf
                                    : FileType.Excel
                                )} />
                        </span>
                    </Tooltip>
                </ListItemAvatar>
                <EllipsisTypography title={report.title} sx={{ maxWidth: selected ? "284px" : undefined }}>{report.title}</EllipsisTypography>
            </ListItem>
        );
    }
}